// LineCallback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const LineCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      axios.post(`${process.env.REACT_APP_API}/login-line`, { code })
        .then(res => {
          const { token, user } = res.data;
          localStorage.setItem("token", token);
          dispatch({ type: "LOGIN", payload: { token, username: user.username, role: user.role } });
          toast.success("Login with LINE success!");
          navigate("/");
        })
        .catch(() => toast.error("Login with LINE failed"));
    }
  }, []);

  return <p>กำลังเข้าสู่ระบบด้วย LINE...</p>;
};

export default LineCallback;
